import {useState} from "react";
import {useNavigate} from "react-router-dom";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";

const currentHour = () => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
};

const InstantiateRouteStatic = ({routeStaticId, disabled = false}) => {
    const [hourStart, setHourStart] = useState(currentHour);
    const [sending, setSending] = useState(false);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertCreated = new SwalAlertChoice({confirmButtonText: "Ver ruta", cancelButtonText: "Cerrar"});

    const onInstantiate = () => {
        if (!hourStart) {
            Alert.warning("Ruta", "Indique la hora de inicio.");
            return;
        }
        setSending(true);
        axiApi
            .post("/api/distribution/static/route/generate/", {id: routeStaticId, hour_start: hourStart})
            .then((resp) => {
                if (resp.data.status) {
                    const routeId = resp.data.route_id;
                    AlertCreated.success("Ruta", "Ruta de hoy instanciada.").then((result) => {
                        if (result.isConfirmed) navigate(`/route-management/route/${routeId}/`);
                    });
                } else {
                    Alert.warning("Ruta", resp.data.message);
                }
            })
            .catch(() => Alert.error("Ruta", "No se ha podido instanciar la ruta."))
            .finally(() => setSending(false));
    };

    return (
        <div className="row pt-4">
            <div className="col-md-4">
                <Form.Label htmlFor="instantiate-hour-start">Hora de inicio</Form.Label>
                <Form.Control
                    id="instantiate-hour-start"
                    type="time"
                    value={hourStart}
                    onChange={(e) => setHourStart(e.target.value)}
                />
                <div className="text-muted small mt-2">Se crea la ruta de hoy, sin camión ni conductor.</div>
                {disabled && (
                    <div className="text-warning small mt-2">Guarde los cambios de la ruta antes de instanciarla.</div>
                )}
                <button
                    type="button"
                    className="btn btn-primary mt-3"
                    disabled={disabled || sending}
                    onClick={onInstantiate}>
                    Instanciar
                </button>
            </div>
        </div>
    );
};

export default InstantiateRouteStatic;
